/**
 * The only analytics the free scaffold inspection due-date tool sends. Every
 * property is a fixed value, so the dates and answers a visitor enters never
 * reach PostHog; pinned by
 * __tests__/marketing/scaffold-inspection-behaviour.test.tsx.
 */
export type ScaffoldInspectionEvent =
  /** The visitor answered a question for the first time on this page view. */
  | { event: "scaffold_due_date_used" }
  /** The visitor answered enough to see a result. */
  | { event: "scaffold_due_date_completed" }
  /** The visitor pressed "Print this record". */
  | { event: "scaffold_due_date_printed" };

interface Capture {
  capture?: (event: string, properties: Record<string, string>) => unknown;
}

export function trackScaffoldInspection(
  posthog: Capture | null | undefined,
  analyticsEvent: ScaffoldInspectionEvent,
): void {
  posthog?.capture?.(analyticsEvent.event, { tool: "scaffold_due_date" });
}
